import {FC, useState} from 'react'
import {Customer} from '../../core/_models'
import {AccountHierarchyModal} from '../../components/AccountHierarchyModal'
import {accountLevelFromParent, getAccountLevelDisplay} from '../../../../../../Utils/accountLevelUtils'
import '../../../../../../Utils/accountLevel.css'

type Props = {
  Customer: Customer
}

const AccountLevelCell: FC<Props> = ({Customer}) => {
  const [showHierarchy, setShowHierarchy] = useState(false)

  const display = getAccountLevelDisplay(accountLevelFromParent(Customer?.parentAccountId))!
  const badgeClassName = `badge account-level-badge ${display.badgeClass} px-3 py-2 fs-9 d-flex align-items-center justify-content-center`

  if (!Customer?.parentAccountId) {
    return <span className={badgeClassName}>{display.label}</span>
  }

  return (
    <>
      <span
        className={`${badgeClassName} account-level-badge-clickable`}
        onClick={() => setShowHierarchy(true)}
      >
        {display.label}
        <i className='bi bi-info-circle ms-2'></i>
      </span>
      {showHierarchy && (
        <AccountHierarchyModal
          show={showHierarchy}
          handleClose={() => setShowHierarchy(false)}
          accountName={Customer?.name}
          parentAccountId={Customer?.parentAccountId}
          parentAccountName={Customer?.parentCustomerName}
        />
      )}
    </>
  )
}

export {AccountLevelCell}
